/**
 *
 * SalaryForm
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { readRemoteFile } from "react-papaparse";

import {
  deepClone,
  constantData,
  setConstantData,
  setResultsData,
  getSelectOptions,
} from "helpers";
import { SnackbarProvider, enqueueSnackbar } from 'notistack';

import DataCSV from "data/data.csv";
import {
  salaryRanges,
  positionsLookupArray,
  experienceLookupArray,
} from "data/data";
import Select from "components/Select";
import Button from "components/Button";
import Radio from "components/Radio";
import Label from "components/Label";
import Toggle from "components/Toggle";
import Checkbox from "components/Checkbox";
import Input from "components/Input";

import SalaryFormWrapper from "./styles/SalaryFormWrapper";
import SalaryRequiredText from "./styles/SalaryRequiredText";
import SalaryHorizontalWrapper from "./styles/SalaryHorizontalWrapper";
import RequiredFields from "./styles/RequiredFields";
import ResultsHorizontalWrapper from "./styles/ResultsHorizontalWrapper";
import ResultsUserResponseWrapper from "./styles/ResultsUserResponseWrapper";
import SignUpWrapper from "./styles/SignUpWrapper";
import ModalWrapper from './styles/ModalWrapper';
import ModalOverlay from './styles/ModalOverlay';
import { auth } from 'firebaseConfig';
import axios from 'axios';

class SalaryForm extends React.PureComponent {
  constructor() {
    super();

    this.handleFilter = this.handleFilter.bind(this);
    this.handleNoFilter = this.handleNoFilter.bind(this);
    this.selectCountry = this.selectCountry.bind(this);
    this.selectCity = this.selectCity.bind(this);
    this.selectState = this.selectState.bind(this);
    this.selectEducation = this.selectEducation.bind(this);
    this.selectExperience = this.selectExperience.bind(this);
    this.selectGender = this.selectGender.bind(this);
    this.selectSalary = this.selectSalary.bind(this);
    this.selectIndustry = this.selectIndustry.bind(this);
    this.selectPosition = this.selectPosition.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRadio = this.handleRadio.bind(this);
    this.handleAdvanced = this.handleAdvanced.bind(this);
    this.showRadio = this.showRadio.bind(this);
    this.setFullName = this.setFullName.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.handleSubmitAuth = this.handleSubmitAuth.bind(this);
    this.handleSignUp = this.handleSignUp.bind(this);
    this.changeAuthType = this.changeAuthType.bind(this);
    this.createGhostMember = this.createGhostMember.bind(this);
    this.createSession = this.createSession.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.sendPasswordShowCallback = this.sendPasswordShowCallback.bind(this);
    this.startOver = this.startOver.bind(this);

    this.state = {
      formData: {
        region: "",
        country: "",
        city: "",
        state: "",
        education: "",
        industry: "",
        position: "",
        experience: "",
        gender: "",
        salary: "",
        userResponseIndex: "",
      },
      filters: {},
      filtersArray: ["country"],
      filtersArrayForm: [],
      countryResponses: [],
      selectedCountryIndexes: [],
      selectedStateIndexes: [],
      countryFormAlert: false,
      fullNameFormAlert: false,
      passwordFormAlert: false,
      emailFormAlert: false,
      showAdvanced: false,
      authForm: {
        full_name: "",
        email: "",
        password: "",
        isSignIn: false,
        submitBtn: true,
        passwordShow: false
      },
      modalOpened: false
    };
  }

  componentDidMount() {
    readRemoteFile(DataCSV, {
      complete: (results) => {
        setConstantData(results.data, this.props.columnHeaders);
        this.setState({
          countryResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("countryResponses")
              : [],
          cityResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("cityResponses")
              : [],
          educationResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("educationResponses")
              : [],
          stateResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("stateResponses")
              : [],
          experienceResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("experienceResponses")
              : [],
          genderResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("genderResponses")
              : [],
          industryResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("industryResponses")
              : [],
          positionResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("positionResponses")
              : [],
          csvData: results.data
        });
      },
    });

    auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in.
        this.props.updatedIsAuthenticated();
      } else {
        // User is signed out.
      }
    });

    // this.handleFilter({
    //   target: {
    //     value: "country",
    //   },
    // });
  }

  componentDidUpdate(prevProps, prevState) {
    // if (prevProps.filtersArray !== this.props.filtersArray) {
    //   this.setState(
    //     {
    //       filtersArray: this.props.filtersArray,
    //     },
    //     () => {
    //       setResultsData({
    //         props: this.props,
    //         filtersArray: this.state.filtersArray,
    //         formData: this.state.formData,
    //       });
    //       // this.props.displayResults();
    //     }
    //   );
    // }

    // if (prevState.formData.country !== this.state.formData.country) {
      
    //   let newFormdata = deepClone(this.state.formData);
    //   newFormdata.state = "";
    //   newFormdata.city = "";
    //   this.setState(
    //     {
    //       formData: newFormdata,
    //     },
    //     () => {
    //       setResultsData({
    //         props: this.props,
    //         filtersArray: this.state.filtersArray,
    //         formData: this.state.formData,
    //       });
    //     }
    //   );
    // }

    // if (prevState.formData.state !== this.state.formData.state) {
    //   let newFormdata = deepClone(this.state.formData);
    //   newFormdata.city = "";
    //   this.setState(
    //     {
    //       formData: newFormdata,
    //     },
    //     () => {
    //       setResultsData({
    //         props: this.props,
    //         filtersArray: this.state.filtersArray,
    //         formData: this.state.formData,
    //       });
    //     }
    //   );
    // }

    if (
      prevState.selectedCountryIndexes.length !==
        this.state.selectedCountryIndexes.length ||
      prevState.selectedStateIndexes.length !==
        this.state.selectedStateIndexes.length
    ) {
      this.setState({
        cityResponses: constantData.responses
          ? getSelectOptions("cityResponses", [
              this.state.selectedCountryIndexes,
              this.state.selectedStateIndexes,
            ])
          : [],
      });
    }
    
  }

  updateFiltersArray(newArray) {
    this.setState({
      filtersArray: newArray,
    });
  }

  handleFilter(event) {
    const value = event.target.value;
    
    const updateFilters = () => {
      const filtersArray = [];
      for (const property in this.state.filters) {
        if (this.state.filters[property]) {
          filtersArray.push(property);
        }
      }
      
      setResultsData({
        props: this.props,
        filtersArray: filtersArray,
        formData: this.state.formData,
      });
      this.props.updateFiltersArray(filtersArray);
    };

    const newFilters = deepClone(this.state.filters);
    
    if (value === "country") {
      this.setState((prevState) => {
        if (newFilters.state && prevState.filters.country) {
          newFilters.state = false;
        }
        if (newFilters.city && prevState.filters.country) {
          newFilters.city = false;
        }
        newFilters.country = !prevState.filters.country;
        return {
          filters: newFilters,
        };
      }, updateFilters);
    } else if (value === "state") {
      this.setState((prevState) => {
        if (!newFilters.country && !prevState.filters.state) {
          newFilters.country = true;
        }
        if (newFilters.city && prevState.filters.state) {
          newFilters.city = false;
        }
        newFilters.state = !prevState.filters.state;
        return {
          filters: newFilters,
        };
      }, updateFilters);
    } else if (value === "city") {
      this.setState((prevState) => {
        if (!newFilters.country && !prevState.filters.city) {
          newFilters.country = true;
        }
        if (!newFilters.state && !prevState.filters.city) {
          newFilters.state = true;
        }
        newFilters.city = !prevState.filters.city;
        return {
          filters: newFilters,
        };
      }, updateFilters);
    } else {
      this.setState((prevState) => {
        newFilters[value] = !prevState.filters[value];
        return {
          filters: newFilters,
        };
      }, updateFilters);
    }
  }

  updateForm(){

  }

  handleNoFilter(){
    
  }

  handleShowCheckbox(filter) {
    const { resultsData } = this.props;
    const { formData } = resultsData;
    if (formData && formData[filter]) {
      if(filter != "country") {
        return (
          <Checkbox
            label={filter.charAt(0).toUpperCase() + filter.slice(1)}
            value={filter}
            checked={this.state.filters[filter]}
            sendDataCallback={this.handleFilter}
          />
        );
      } else {
        return (
          <Checkbox
            label={filter.charAt(0).toUpperCase() + filter.slice(1)}
            value={filter}
            checked={this.state.filters[filter]}
            sendDataCallback={this.handleNoFilter}
          />
        );
      }
      
    }
  }

  handleShowResponse(whichResponse) {
    
    // const formData = this.props.resultsData.formData;
    // const label =
    //   whichResponse.charAt(0).toUpperCase() + whichResponse.slice(1);
    // if (formData && formData[whichResponse]) {
    //   return (
    //     <ResultsUserResponse
    //       hasLineThrough={!this.state.filters[whichResponse]}
    //     >
    //       {`${label}:`}
    //       <span>{`${formData[whichResponse]}`}</span>
    //     </ResultsUserResponse>
    //   );
    // }
  }

  selectCountry(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.country = val;
      let countryIndexes = [];
      constantData.responses.countryResponses.forEach((response, index) => {
        if (response === val) {
          countryIndexes.push(index);
        }
      });
      
      return {
        formData: newFormData,
        selectedCountryIndexes: countryIndexes,
        selectedStateIndexes: [],
      };
    });

    // if (val && !this.state.filtersArrayForm.includes("country")) {
    //   this.state.filtersArrayForm.push("country");
    // }

    this.setState({
      countryFormAlert: false,
    });
  }

  selectState(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.state = val;

      let stateIndexes = [];
      constantData.responses.stateResponses.forEach((response, index) => {
        if (response === val) {
          stateIndexes.push(index);
        }
      });

      return {
        formData: newFormData,
        selectedStateIndexes: stateIndexes,
      };
    });

    if(val){
      if(!this.state.filtersArrayForm.includes("state")){
        this.state.filtersArrayForm.push("state");
      }
    } else {
      const filterArray = this.state.filtersArrayForm.filter(state => state !== 'state');
      this.state.filtersArrayForm = filterArray;
    }
  }

  selectCity(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.city = val;
      return { formData: newFormData };
    });

    if(val){
      if(!this.state.filtersArrayForm.includes("city")){
        this.state.filtersArrayForm.push("city");
      }
    } else {
      const filterArray = this.state.filtersArrayForm.filter(city => city !== 'city');
      this.state.filtersArrayForm = filterArray;
    }
  }

  selectEducation(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.education = val;
      return { formData: newFormData };
    });

    if(val){
      if(!this.state.filtersArrayForm.includes("education")){
        this.state.filtersArrayForm.push("education");
      }
    } else {
      const filterArray = this.state.filtersArrayForm.filter(education => education !== 'education');
      this.state.filtersArrayForm = filterArray;
    }
  }

  selectExperience(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.experience = val;
      return { formData: newFormData };
    });
    
    if(val){
      if(!this.state.filtersArrayForm.includes("experience")){
        this.state.filtersArrayForm.push("experience");
      }
    } else {
      const filterArray = this.state.filtersArrayForm.filter(experience => experience !== 'experience');
      this.state.filtersArrayForm = filterArray;
    }
  }

  selectGender(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.gender = val;
      return { formData: newFormData };
    });

    if(val){
      if(!this.state.filtersArrayForm.includes("gender")){
        this.state.filtersArrayForm.push("gender");
      }
    } else {
      const filterArray = this.state.filtersArrayForm.filter(gender => gender !== 'gender');
      this.state.filtersArrayForm = filterArray;
    }
  }

  selectSalary(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.salary = val;
      newFormData.userResponseIndex = salaryRanges.indexOf(val.charAt(0).toLowerCase() + val.slice(1));
      return { formData: newFormData };
    });
  }

  selectIndustry(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.industry = val;
      return { formData: newFormData };
    });

    if(val){
      if(!this.state.filtersArrayForm.includes("industry")){
        this.state.filtersArrayForm.push("industry");
      }
    } else {
      const filterArray = this.state.filtersArrayForm.filter(industry => industry !== 'industry');
      this.state.filtersArrayForm = filterArray;
    }
  }

  selectPosition(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.position = val;
      return { formData: newFormData };
    });

    if(val){
      if(!this.state.filtersArrayForm.includes("position")){
        this.state.filtersArrayForm.push("position");
      }
    } else {
      const filterArray = this.state.filtersArrayForm.filter(position => position !== 'position');
      this.state.filtersArrayForm = filterArray;
    }
  }

  handleRadio(event) {
    const type = event.target.name;
    const value = event.target.value;
    const newFormData = deepClone(this.state.formData);
    if (this.state.formData[type] === value) {
      newFormData[type] = "";
      this.setState({
        formData: newFormData,
      });
    } else {
      newFormData[type] = value;
      this.setState({
        formData: newFormData,
      });
    }
    
    if(value){
      if(!this.state.filtersArray.includes(type)){
        this.state.filtersArray.push(type);
      }
    } else {
      const filterArray = this.state.filtersArray.filter(position => position !== type);
      this.state.filtersArray = filterArray;
    }
  }

  handleClick() {

    const { formData } = this.state;
    const { country } = formData;

    if (country) {
      
      const resultObject = this.state.filtersArray.reduce((acc, currentValue) => {
        if(currentValue == "country"){
          acc[currentValue] = true;
        }else {
          acc[currentValue] = false;
        }
        return acc;
      }, {});

      this.state.filters = resultObject;

      setResultsData({
        props: this.props,
        filtersArray: this.state.filtersArray,
        formData: this.state.formData,
      });

      this.props.updateFiltersArray(this.state.filtersArray);
      this.props.displayResults();
      this.setState({
        countryFormAlert: false,
      });
    } else {
      this.setState({
        countryFormAlert: true,
      });
    }

    // window.scroll({
    //   top: 0,
    //   left: 0,
    //   behavior: "smooth",
    // });
    const salaryContainer = document.getElementById("App");

    // Scroll to the selected element
    salaryContainer.scrollIntoView({ behavior: 'smooth' });
  }

  handleOpenModal() {
    // this.state.modalOpened = true;
    this.setState(prevState => ({
      modalOpened: !prevState.modalOpened
    }));
  }

  handleSubmitAuth(){
    
    this.setState(prevState => ({
      authForm: {
        ...prevState.authForm,
        submitBtn: false
      }
    }));

    let ifValidationSucceed = true;

    if(this.state.authForm.isSignIn){

      if(!this.state.authForm.email){
        ifValidationSucceed = false;
        this.setState({
          emailFormAlert: true,
        });
      }

      if(!this.state.authForm.password){
        ifValidationSucceed = false;
        this.setState({
          passwordFormAlert: true,
        });
      }

      if(ifValidationSucceed){
        this.handleSignIn();
      } else {
        this.setState(prevState => ({
          authForm: {
            ...prevState.authForm,
            submitBtn: true
          }
        }));
      }

    } else {

      if(!this.state.authForm.full_name){
        ifValidationSucceed = false;
        this.setState({
          fullNameFormAlert: true,
        });
      }

      if(!this.state.authForm.email){
        ifValidationSucceed = false;
        this.setState({
          emailFormAlert: true,
        });
      }

      if(!this.state.authForm.password){
        ifValidationSucceed = false;
        this.setState({
          passwordFormAlert: true,
        });
      }

      if(ifValidationSucceed){
        this.handleSignUp();
      } else {
        this.setState(prevState => ({
          authForm: {
            ...prevState.authForm,
            submitBtn: true
          }
        }));
      }
    }
  }

  changeAuthType(e){
    e.preventDefault();

    this.setState(prevState => ({
      authForm: {
        ...prevState.authForm,
        isSignIn: !prevState.authForm.isSignIn
      }
    }));
  }

  sendPasswordShowCallback(){
    this.setState(prevState => ({
      authForm: {
        ...prevState.authForm,
        passwordShow: !prevState.authForm.passwordShow
      }
    }));
  }

  async handleSignUp(){
    const email = this.state.authForm.email;
    const password = this.state.authForm.password;
    const full_name = this.state.authForm.full_name;
    try {
      await auth.createUserWithEmailAndPassword(email, password);
      // User signed up successfully
      this.props.updatedIsAuthenticated();
      // this.createGhostMember(full_name, email);
      this.sendMagicLink(email, full_name);
      const message = "You're successfully signed up!";
      enqueueSnackbar(message, { autoHideDuration: 3000, variant: 'success', });
      this.setState(prevState => ({
        authForm: {
          ...prevState.authForm,
          submitBtn: true
        }
      }));
      
    } catch (error) {

      if(error.message == "Firebase: The email address is badly formatted. (auth/invalid-email)."){
        const message = 'Email invalid format!';
        enqueueSnackbar(message, { autoHideDuration: 3000, variant: 'error', });
        this.setState(prevState => ({
          authForm: {
            ...prevState.authForm,
            submitBtn: true
          }
        }));
      }else {
        const message = 'Email already used!';
        enqueueSnackbar(message, { autoHideDuration: 3000, variant: 'error', });
        this.setState(prevState => ({
          authForm: {
            ...prevState.authForm,
            submitBtn: true
          }
        }));
      }
      
    }
  }

  async handleSignIn(){
    const email = this.state.authForm.email;
    const password = this.state.authForm.password;

    try {
      await auth.signInWithEmailAndPassword(email, password);
      // this.createSession(email, password);
      const message = "You're successfully signed in!";
      enqueueSnackbar(message, { autoHideDuration: 3000, variant: 'success', });
      this.props.updatedIsAuthenticated();
      this.setState(prevState => ({
        authForm: {
          ...prevState.authForm,
          submitBtn: true
        }
      }));
    } catch (error) {
      if(error.message == "Firebase: Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later. (auth/too-many-requests)."){
        const message = 'Too many request!';
        enqueueSnackbar(message, { autoHideDuration: 3000, variant: 'error', });
      } else if(error.message == "Firebase: The password is invalid or the user does not have a password. (auth/wrong-password).") {
        const message = 'Incorrect password!';
        enqueueSnackbar(message, { autoHideDuration: 3000, variant: 'error', });
      } else {
        const message = 'User not found!';
        enqueueSnackbar(message, { autoHideDuration: 3000, variant: 'error', });
      }
      this.setState(prevState => ({
        authForm: {
          ...prevState.authForm,
          submitBtn: true
        }
      }));
    }
  }

  async createSession(email, password){
     // Create a token without the client
     const jwt = require('jsonwebtoken');
    
     // Admin API key goes here
     //local
     const key = '65f7bd591fc1320af411f57d:974950fdcf812daeca37be8f6b6fc25f2a444b0a78aa30e172ed51cec4b8e39f';
     //live
     //const key = '65f7bd591fc1320af411f57d:974950fdcf812daeca37be8f6b6fc25f2a444b0a78aa30e172ed51cec4b8e39f';
 
     // Split the key into ID and SECRET
     const [id, secret] = key.split(':');
 
     // Create the token (including decoding secret)
     try {
 
       const token = await jwt.sign({}, Buffer.from(secret, 'hex'), {
           keyid: id,
           algorithm: 'HS256',
           expiresIn: '5d',
           audience: `/admin/`
       });
       
       // Make an authenticated request to create a post
       const url = 'http://localhost:2368/ghost/api/admin/session/';
       const headers = {
          Authorization: `Ghost ${token}`,
          "Accept-Version": "v3.0",
          Origin: "http://localhost:2368",
          'Content-Type': 'application/x-www-form-urlencoded' // Adjust content type
        };
       const payload = { "email": email, "password": password };
 
       await axios.post(url, payload, { headers, withCredentials: true })
           .then(response => console.log(response))
           .catch(error => console.error(error));
 
       // await axios.get(url, { headers })
       //     .then(response => console.log(response))
       //     .catch(error => console.error(error));
 
     } catch (error) {
         console.error("Error creating token:", error);
     }
  }

  async createGhostMember(name, email){
    // Create a token without the client
    const jwt = require('jsonwebtoken');

    let key;
    // Admin API key goes here
    if(window.location.origin == "http://localhost:3000" || window.location.origin == "http://localhost:2368"){
      //local
      key = '65f7bd591fc1320af411f57d:974950fdcf812daeca37be8f6b6fc25f2a444b0a78aa30e172ed51cec4b8e39f';
    } else {
      //live
      key = "65fa781dcd032400019f9e21:b5b48d22e66489e4889335565fb2306e72044de3e8b8fcc7fc5bd1055f2b6e98";
    }

    // Split the key into ID and SECRET
    const [id, secret] = key.split(':');

    // Create the token (including decoding secret)
    try {

      const token = await jwt.sign({}, Buffer.from(secret, 'hex'), {
          keyid: id,
          algorithm: 'HS256',
          expiresIn: '5d',
          audience: `/admin/`
      });

      // Make an authenticated request to create a post
      const url = 'https://product-marketing-alliance.ghost.io/ghost/api/admin/members/';
      const headers = { Authorization: `Ghost ${token}` };
      const payload = { members: [ { "email": email, "nam": name, "labels": [
        {
          "name": "Salary Calculator",
          "slug": "salarycalculator"
        }
      ]}] };

      await axios.post(url, payload, { headers })
          .then(response => console.log(response))
          .catch(error => console.error(error));

      // await axios.get(url, { headers })
      //     .then(response => console.log(response))
      //     .catch(error => console.error(error));

    } catch (error) {
        console.error("Error creating token:", error);
    }
  }

  async sendMagicLink(email, full_name) {
    // Create a token without the client
    const jwt = require('jsonwebtoken');

    let key;
    // Admin API key goes here
    if(window.location.origin == "http://localhost:3000" || window.location.origin == "http://localhost:2368"){
      //local
      key = '65f7bd591fc1320af411f57d:974950fdcf812daeca37be8f6b6fc25f2a444b0a78aa30e172ed51cec4b8e39f';
    } else {
      //live
      key = "65fa781dcd032400019f9e21:b5b48d22e66489e4889335565fb2306e72044de3e8b8fcc7fc5bd1055f2b6e98";
    }

    // Split the key into ID and SECRET
    const [id, secret] = key.split(':');

    // Create the token (including decoding secret)
    try {

      const token = await jwt.sign({}, Buffer.from(secret, 'hex'), {
          keyid: id,
          algorithm: 'HS256',
          expiresIn: '5d',
          audience: `/admin/`
      });

      // Make an authenticated request to create a post
      const url = 'https://www.productmarketingalliance.com/members/api/send-magic-link/';
      const headers = { Authorization: `Ghost ${token}` };
      const payload = {
        "name": full_name,
        "email": email,
        "labels": [
          {
            "name": "Salary Calculator",
            "slug": "salarycalculator"
          }
        ],
        "newsletters": [
            {
                "id": "6270e32e8d747c003151f51b"
            },
            {
                "id": "6303a2c51200ad003dfc3219"
            }
        ],
        "emailType": "signup",
        "requestSrc": "portal",
        "autoRedirect": true,
        "urlHistory": []
      };

      await axios.post(url, payload, { headers })
          .then(response => {
            console.log(response);
          })
          .catch(error => console.error(error));

    } catch (error) {
        console.error("Error creating token:", error);
    }
  }

  setFullName(value){
    this.state.authForm.full_name = value;
    if(value){
      this.setState({
        fullNameFormAlert: false,
      });
    } else {
      this.setState({
        fullNameFormAlert: true,
      });
    }
  }

  setEmail(value){
    this.state.authForm.email = value;
    if(value){
      this.setState({
        emailFormAlert: false,
      });
    } else {
      this.setState({
        emailFormAlert: true,
      });
    }
  }

  setPassword(value){
    this.state.authForm.password = value;
    if(value){
      this.setState({
        passwordFormAlert: false,
      });
    } else {
      this.setState({
        passwordFormAlert: true,
      });
    }
  }

  handleAdvanced() {
    this.setState((prevProps) => {
      return {
        showAdvanced: !prevProps.showAdvanced,
      };
    });
  }

  moveCountriesToTop(countries, country1, country2) {
      // Remove the countries from their current positions
      let index1 = countries.indexOf(country1);
      let index2 = countries.indexOf(country2);
    
      if (index1 !== -1 && index2 !== -1) {
          countries.splice(index1, 1);
          countries.splice(index2, 1);
      }

      // Move the countries to the top
      countries.unshift(country2);
      countries.unshift(country1);

      return countries;
  }

  startOver() {
    this.setState(() => {
      return {
        formData: {
          region: "",
          country: "",
          city: "",
          state: "",
          education: "",
          industry: "",
          position: "",
          experience: "",
          gender: "",
          salary: "",}
      };
    });

    this.setState(() => {
      return {
        showAdvanced: false,
      };
    });

    this.props.resetForm();
  }

  showRadio(name, responses, label) {
    const radioArray = responses
      ? responses.map((response, index) => {
          return (
            <Radio
              label={response.charAt(0).toUpperCase() + response.slice(1)}
              value={response}
              sendDataCallback={this.handleRadio}
              name={name}
              checked={this.state.formData[name]}
              key={index}
            />
          );
        })
      : "";
    const result = (
      <>
        <Label title={label} />
        <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
          {radioArray}
        </div>
      </>
    );
    return result;
  }

  render() {
    const {
      formData,
      countryResponses,
      stateResponses,
      educationResponses,
      experienceResponses,
      genderResponses,
      industryResponses,
      positionResponses,
      cityResponses,
      showAdvanced,
      authForm,
      modalOpened
    } = this.state;

    const { country, city, state, position, education, industry, experience, gender, salary, } = this.state.formData;
    const { isResultsDisplayed } = this.props;
    const { isAuthenticated } = this.props;
    const { countryFormAlert, fullNameFormAlert, emailFormAlert, passwordFormAlert } = this.state;

    let modifiedCountries = "";
    if(countryResponses) {
      modifiedCountries = this.moveCountriesToTop(countryResponses.sort(), "United Kingdom", "United States")
    }

    let uniqueCountryArray = [...new Set(modifiedCountries)];
    return (
      <SalaryFormWrapper 
      className={`form-container ${isResultsDisplayed ? "result-opened" : ""}`}
      >
        {!isResultsDisplayed ? (
          <div className="sf-section__title">
            <h3 className="h3-d">
              <span>Fill in the form </span>
              <br />
              <span className="stl-1">to calculate...</span>
            </h3>
            <div className="sf-section__title__shape">
              <img src="/assets/img/salary/sf-section__title__shape.svg" alt="" />
            </div>
          </div>
        ) : (
          <div className="sf-section__title">
            <h3 className="h3-d tr-form__title">
              <span>The results</span>
              <br />
              <span className="stl-1">are in...</span>
            </h3>
            {isAuthenticated || !isAuthenticated && !isResultsDisplayed ? (
              <div>
            <h3
              style={{
                marginTop: "24px",
              }}
            >
              {"Filter by:"}
            </h3>
              <ResultsHorizontalWrapper>
                {this.handleShowCheckbox("country")}
                {this.handleShowCheckbox("state")}
                {this.handleShowCheckbox("city")}
                {this.handleShowCheckbox("industry")}
                {this.handleShowCheckbox("position")}
                {this.handleShowCheckbox("education")}
                {this.handleShowCheckbox("experience")}
                {this.handleShowCheckbox("gender")}
              </ResultsHorizontalWrapper>
              <ResultsUserResponseWrapper>
                {this.handleShowResponse("country")}
                {this.handleShowResponse("state")}
                {this.handleShowResponse("city")}
                {this.handleShowResponse("industry")}
                {this.handleShowResponse("position")}
                {this.handleShowResponse("education")}
                {this.handleShowResponse("experience")}
                {this.handleShowResponse("gender")}
              </ResultsUserResponseWrapper>
            </div>
            ) : (
              ""
            )}
          </div>
        )}
        {isAuthenticated || !isAuthenticated && !isResultsDisplayed ? (
        <div className={(!isResultsDisplayed ? "sf-section__main" : "w-387")}>
          {/* <SalaryHeader>Salary calculator</SalaryHeader> */}
          {/* <SalaryInfo>{formIntro}</SalaryInfo> */}
          <Select
            options={uniqueCountryArray}
            sendDataCallback={this.selectCountry}
            label={"Select your country"}
            isRequired={true}
            showError={countryFormAlert}
            value={country}
          />
          {country === "United States" ? (
            <Select
              options={stateResponses && stateResponses.sort()}
              sendDataCallback={this.selectState}
              label={"Select your state"}
              value={state}
            />
          ) : (
            ""
          )}
          <Select
            options={positionResponses && positionsLookupArray}
            sendDataCallback={this.selectPosition}
            label={"Select your position"}
            value={position}
          />
          <Select
            options={industryResponses && industryResponses.sort()}
            sendDataCallback={this.selectIndustry}
            label={"Select industry"}
            value={industry}
          />
          <Select
            options={salaryRanges}
            sendDataCallback={this.selectSalary}
            isSalaryRange={true}
            label={"Select your current annual salary range (USD)"}
            value={salary}
          />
            <RequiredFields>
              <Toggle
                label={"Show advanced options"}
                handleToggle={this.handleAdvanced}
              />
              <SalaryRequiredText />
            </RequiredFields>
          {showAdvanced ? (
            <>
              <Select
                options={cityResponses && cityResponses.sort()}
                sendDataCallback={this.selectCity}
                label={"Select your city"}
                value={city}
              />
              
              {/* {this.showRadio(
                "education",
                educationResponses,
                "Select your education level"
              )} */}
                <Select
                  options={educationResponses && educationResponses.sort()}
                  sendDataCallback={this.selectEducation}
                  label={"Select your education level"}
                  value={education}
                />
              {/* {this.showRadio(
                "experience",
                experienceLookupArray,
                "Select your experience"
              )} */}
                <Select
                  options={experienceLookupArray && experienceLookupArray.sort()}
                  sendDataCallback={this.selectExperience}
                  label={"Select your experience"}
                  value={experience}
                />
              
              {/* {this.showRadio("gender", genderResponses, "Select your gender")} */}
                <Select
                  options={genderResponses && genderResponses.sort()}
                  sendDataCallback={this.selectGender}
                  label={"Select your gender"}
                  value={gender}
                />
            </>
          ) : (
            ""
          )}
          <SalaryHorizontalWrapper>
            <Button
              title={"Calculate salary"}
              handleClick={this.handleClick}
              disabled={!formData.country}
              className={"btn-primary"}
            />
          </SalaryHorizontalWrapper>
          {/* <SalaryHorizontalWrapper>
            <Button
              title={"Calculate Salary"}
              handleClick={this.handleClick}
              disabled={
                !formData.country ||
                !formData.position ||
                !formData.industry ||
                !formData.salary
              }
            />
          </SalaryHorizontalWrapper> */}
        </div>
        ) : (
          <SignUpWrapper>
            <ModalOverlay className={modalOpened ? "show" : ""}>
              <ModalWrapper className="salary-modal">
                <a onClick={this.handleOpenModal} className="modal-close"></a>
                <h2 className="modal-title">Enter your</h2>
                <h2 className="font-italic">Email</h2>
                <div className="auth-form">
                  {!authForm.isSignIn ? (
                    <div>
                      <p className="info">Already have access? &nbsp;<a onClick={this.changeAuthType}>Login here</a>.</p>
                      <Input 
                        label="Full name" 
                        sendDataCallback={this.setFullName}
                        isRequired={authForm.isSignIn ? false : true}
                        showError={fullNameFormAlert}
                      />
                    </div>
                  ) : ( ""
                  )}
                  <Input 
                    label="Email" 
                    type="email" 
                    sendDataCallback={this.setEmail}
                    isRequired={true}
                    showError={emailFormAlert}
                  />
                  <Input 
                    label="Password" 
                    type={authForm.passwordShow ? "text" : "password" }
                    isPassword={true}
                    passwordShow={authForm.passwordShow}
                    sendDataCallback={this.setPassword}
                    sendPasswordShowCallback={this.sendPasswordShowCallback}
                    isRequired={true}
                    showError={passwordFormAlert}
                  />
                  <Button
                    title={!authForm.isSignIn ? ( "Create your account" ) : ( "Login" )}
                    handleClick={this.handleSubmitAuth}
                    disabled={!authForm.submitBtn}
                    className={"btn-primary"}
                  />
                </div>
                {!authForm.isSignIn ? (
                <p>By joining, you are agreeing to our <a href="https://www.productmarketingalliance.com/terms-conditions/">Terms</a> and <a href="https://www.productmarketingalliance.com/privacypolicy/">Privacy Policy</a>.  </p>
                ) : ( 
                  <p>Don’t have access? <a onClick={this.changeAuthType}>Sign up here.</a> </p>
                )}
                
              </ModalWrapper>
            </ModalOverlay>
            <p>Oops! You must be an insider member to see the results.</p> <br></br>
            <p>Don’t worry! Registration is free. Sign up now and gain access to our resources.</p>
            <div className="btn-group">
              <Button
                title={"Sign up for free"}
                isSecondary={true}
                className={"btn-secondary"}
                handleClick={this.handleOpenModal}
              />
              <a target="_blank" href="https://www.productmarketingalliance.com/insider-membership-plan/">
                <Button
                  title={"Learn more"}
                  className={"btn-primary-outline"}
                />
              </a>
            </div>
          </SignUpWrapper>
        )}
        <SnackbarProvider/>
      </SalaryFormWrapper>
    );
  }
}

SalaryForm.propTypes = {
  columnHeaders: PropTypes.object,
  salaryRanges: PropTypes.array,
  isResultsDisplayed: PropTypes.bool
};

export default SalaryForm;
